import { Component, computed, input } from '@angular/core';
import { StateToAccentColorMap, StateToTextColorMap } from 'dashboard/constants/visuals-dashboard/state-to-colors-maps';
import { IceDashboardDisplayStateEnum } from 'dashboard/enums/visuals/ice-dashboard-display-state.enum';
import { VisualsDashboardRangesColorEnum, VisualsDashboardTextColorEnum } from 'dashboard/enums/visuals/visuals-dashboard-colors.enum';

interface StateConfig {
    accent: VisualsDashboardRangesColorEnum;
    text: VisualsDashboardTextColorEnum;
}

@Component({
    selector: 'app-ice-visuals-dashboard-large-number-display',
    imports: [],
    templateUrl: './ice-visuals-dashboard-large-number-display.component.html',
    styleUrl: './ice-visuals-dashboard-large-number-display.component.scss',
})
export class IceVisualsDashboardLargeNumberDisplayComponent {
    value = input.required<number>();
    label = input.required<string>();
    loading = input<boolean>(false);
    isEmpty = input<boolean>(false);
    state = input<IceDashboardDisplayStateEnum | null>(IceDashboardDisplayStateEnum.NEUTRAL);
    emptyStateMessage = input<string>('No data available');
    emptyStateIcon = input<string | null>(null);
    icon = input<string | null>(null);

    stateConfig = computed<StateConfig>(() => {
        let state = this.state();
        if (!state) {
            state = IceDashboardDisplayStateEnum.NEUTRAL;
        }
        return {
            accent: StateToAccentColorMap[state],
            text: StateToTextColorMap[state],
        };
    });
}
